import { getAccessToken } from '@/backend/auth/tokenStorage.mjs'

function readImpersonationAccessToken() {
  // sessionStorage первым — имперсонализация (per-tab токен).
  try {
    const sessionUser = JSON.parse(sessionStorage.getItem('user'))
    if (sessionUser && sessionUser.access_token) return sessionUser.access_token
  } catch { /* ignore parse errors */ }
  return null
}

export default function authHeader() {
  const accessToken = readImpersonationAccessToken() || getAccessToken()
  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
  if (accessToken) {
    headers.Authorization = 'Bearer ' + accessToken
  }
  return headers
}
